// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { TEntityStatus } from '~/misc/opportunity/types';
import type { TOpportunityDataClientModel } from '~/misc/listings/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

export class ManagerOpportunityModel
  extends ManagerResource
  implements TOpportunityDataClientModel
{
  protected endpoint: string = 'opportunity/';

  entityStatuses(requestConfig?: TApiHttpClientRequestConfig): Promise<TEntityStatus[]> {
    return this.get<TEntityStatus[]>('entity-statuses', undefined, requestConfig);
  }
}
